/* Hey Hottie — the free-shipping bar
 *
 * The bar is rendered by Liquid, so it is right on first paint. This only
 * keeps it right afterwards: Stiletto swaps the cart markup out on every
 * change, so we re-read the cart and repaint whatever bars exist now.
 */
(function () {
  'use strict';

  function root() {
    return ((window.Shopify && window.Shopify.routes) || {}).root || '/';
  }

  function money(cents) {
    var n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  var COPY = {};

  function paint(cart) {
    var bars = document.querySelectorAll('[data-hh-ship]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var goal = parseInt(bar.getAttribute('data-goal'), 10) || 0;
      if (!goal) continue;

      /* An empty cart gets no bar. "$75 away" on nothing is a price tag, not
         a nudge. */
      if (!cart.item_count) { bar.hidden = true; continue; }
      bar.hidden = false;

      var left = goal - cart.total_price;
      var text = bar.querySelector('[data-hh-ship-text]');
      var fill = bar.querySelector('[data-hh-ship-fill]');

      if (left <= 0) {
        bar.classList.add('hh-ship--done');
        if (text) text.textContent = COPY.done || '';
        if (fill) fill.style.width = '100%';
      } else {
        bar.classList.remove('hh-ship--done');
        if (text) text.textContent = (COPY.text || '').replace('[amount]', money(left));
        if (fill) fill.style.width = Math.min(100, (cart.total_price / goal) * 100) + '%';
      }
    }
  }

  function refresh() {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () { /* leave whatever Liquid rendered */ });
  }

  function boot() {
    var tag = document.querySelector('[data-hh-ship-copy]');
    if (tag) {
      try { COPY = JSON.parse(tag.textContent); } catch (e) { COPY = {}; }
    }
    /* Stiletto replaces the cart markup wholesale, so every one of these means
       the bars on the page may be stale or brand new. */
    ['cart:updated', 'cart:item-added', 'quick-cart:updated', 'quick-cart:open', 'hh:cart-changed']
      .forEach(function (name) { document.addEventListener(name, refresh); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ──────────────────────────────────────────────────────────────────────────
   The cart add-ons
   One tap adds and reloads. Reloading is deliberate: Stiletto owns the cart
   markup, and re-rendering it from here would fight the theme for control of
   the same DOM. A cart reload is cheap and always correct.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hh-addon]');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = '…';

    var base = ((window.Shopify && window.Shopify.routes) || {}).root || '/';

    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-hh-addon'), quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (d) {
          if (!res.ok) throw new Error(d.description || d.message || 'no');
          return d;
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = was;
        console.warn('[hey hottie] add-on failed:', err);
      });
  });
})();
